import { withRouter } from 'react-router-dom'
import { View as ViewComponent } from './View'

export const View = withRouter(ViewComponent)
